/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import { Checkbox, FormControlLabel, FormHelperText, Box } from "@mui/material";

const RHFCheckbox = ({ formData, control, values, isDisabled }) => {
    // Generate validation rules dynamically
    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        }
        return acc;
    }, {});

    const isCheckDisabled = isDisabled || (values?.ParentschemeId && ['ExcludeException', 'GroupApplicable', 'IsStandard', 'IsParentScheme'].includes(formData?.ValueExpr));

    return (
        <Controller
            name={formData?.ValueExpr}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) => (
                <Box>
                    <FormControlLabel
                        disabled={isCheckDisabled}
                        control={
                            <Checkbox
                                {...field}
                                checked={!!field.value}
                                onChange={(e) => field.onChange(e.target.checked)}
                                style={{ transform: 'scale(0.8)' }}
                                disabled={isCheckDisabled}
                            />
                        }
                        label={
                            <>  
                                <span style={{ color: isCheckDisabled ? 'rgba(0, 0, 0, 0.38)' : "black" }}>{formData?.LabelName || formData?.DisplayExpr}</span>
                                {rules?.required && (
                                    <span style={{ color: isCheckDisabled ? 'rgba(0, 0, 0, 0.38)' : "red", marginLeft: "2px" }}>*</span>
                                )}
                            </>
                        }
                        sx={{
                            "& .MuiFormControlLabel-label": {
                                fontSize: "13px",
                                color: isCheckDisabled ? 'rgba(0, 0, 0, 0.38)' : undefined,
                            },
                        }}
                    />
                    {error && (
                        <FormHelperText error sx={{ fontSize: "10px", ml: 1.5 }}>
                            {error.message}
                        </FormHelperText>
                    )}
                </Box>
            )}
        />
    );
};

export default RHFCheckbox;
